module.exports = __webpack_public_path__ + "img/logo_auth.093a91b0.svg";